import {
  CREATE_PVS_KEYWORD_REQUEST,
  CREATE_PVS_KEYWORD_SUCCESS,
  CREATE_PVS_KEYWORD_FAILURE,
  RESET_PVS_KEYWORD_STATE,
} from '../../../types/pvs';

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
};

const createPvsKeywordReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PVS_KEYWORD_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      };

    case CREATE_PVS_KEYWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload?.message || "Keyword created successfully",
      };

    case CREATE_PVS_KEYWORD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        message: action.payload?.message || "Failed to create keyword",
      };

    case RESET_PVS_KEYWORD_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default createPvsKeywordReducer;
